import { useMemo } from 'react';
import type {
  ShipId,
  ShipVoyageNamingRuleRelationId,
  VoyageNamingRule_AdminFragment,
  VoyageNamingRuleId,
} from '../../graphql';
import {
  useAllShipVoyageNamingRuleRelationsQuery,
  useShipVoyageNamingRuleRelationUpdatedSubscription,
} from '../../graphql';

export function useVoyageNamingRules(org_id: number | null) {
  const { data, refetch } = useAllShipVoyageNamingRuleRelationsQuery();
  useShipVoyageNamingRuleRelationUpdatedSubscription({
    variables: {
      org: (org_id || -1).toString(),
    },
    skip: typeof window === 'undefined' || !org_id,
    onData: async () => {
      await refetch();
    },
  });

  return useMemo(() => {
    const result: Map<
      ShipId,
      {
        id: ShipVoyageNamingRuleRelationId;
        rule_id: VoyageNamingRuleId;
        rule: VoyageNamingRule_AdminFragment;
      }
    > = new Map();
    data?.allShipVoyageNamingRuleRelations?.nodes.forEach((node) => {
      if (!node) {
        return;
      }
      const rule = node.voyageNamingRuleByRuleId;
      if (rule) {
        result.set(node.shipId, { id: node.id, rule_id: node.ruleId, rule });
      }
    });
    return result;
  }, [data?.allShipVoyageNamingRuleRelations]);
}
